import { Component, OnInit, ViewChild, OnDestroy, ɵConsole, Input } from '@angular/core';
import { MediaFile, ConfirmDialogData, RenameFileDialogData, FileNode, FolderNode, MediaTree, UploadFileDialogData, FileDialogData, ErrorCodes, Error } from 'src/app/utils/common-classes';
import { MatMenuTrigger, MatDialogRef, MatDialog, MatTableDataSource } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { RenameFileDialogComponent } from '../rename-file-dialog/rename-file-dialog.component';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/services/File/file.service';
import { UtilsService } from 'src/app/services/Utils/utils.service';
import { SelectionChange, SelectionModel } from '@angular/cdk/collections';
import { UploadFileDialogComponent } from '../upload-files-dialog/upload-files-dialog.component';
import { MoveFilesDialogComponent } from '../move-files-dialog/move-files-dialog.component';
import { UploadService } from 'src/app/services/Upload/upload.service';

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.scss']
})
export class FileManagerComponent implements OnInit, OnDestroy {

  @ViewChild('fileMenuTrigger', { static: true, read: MatMenuTrigger })
  public fileMenuTrigger: MatMenuTrigger;
  public fileMenuTriggerSubscription: Subscription;
  public mediaFolder: FolderNode;
  public mediaTree: MediaTree;

  public gridView: boolean = true;
  public files: Array<FileNode> = [];
  public selectedFile: FileNode;
  public fileSelection: boolean = false;

  public masterChecked: boolean = false;
  public masterIndeterminate: boolean = false;

  public listDataSource: MatTableDataSource<FileNode>;
  public displayedColumns: string[] = ['select', 'name', 'description'];
  public selection = new SelectionModel<FileNode>(true, []);
  public selectionChangeSubscription: Subscription;

  contextMenuPosition = { x: '0px', y: '0px' };

  constructor(private dialog: MatDialog,
    private fileService: FileService,
    public utils: UtilsService,
    public uploadService: UploadService) {
  }

  onContextMenu(event: MouseEvent, file: FileNode): void {
    event.preventDefault();
    this.selectedFile = file;
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.fileMenuTrigger.menuData = { 'file': file };
    this.fileMenuTrigger.menu.focusFirstItem('mouse');
    this.fileMenuTrigger.openMenu();
  }

  public loadFolder(folder: FolderNode, tree: MediaTree): void {
    let _self = this;
    if (folder) {
      _self.mediaFolder = folder;
      _self.mediaTree = tree;
      _self.selection.clear();
      _self.files = [];
      _self.utils.showShortLoader();
      _self.fileService.getFiles(folder.mediaFolderId).then((files: Array<MediaFile>) => {
        files.forEach((file) => {
          _self.files.push(FileNode.fromMediaFile(file));
        });

        _self.listDataSource = new MatTableDataSource<FileNode>(_self.files);
      }).catch((err) => {
        return _self.utils.getErrorShowToast(err);
      }).finally(() => {
        _self.utils.hideShortLoader();
      });
    }
  }

  public downloadFile(file: FileNode): void {
    let _self = this;
    //window.open(file.url, 'Download'); 
    const a = document.createElement('a');
    a.href = file.url;
    a.download = file.getName(_self.utils.getLanguage());
    a.click();
  }

  public renameFile(file: FileNode): void {
    let _self = this;
    let data: RenameFileDialogData = { file: file };
    let dialogRef: MatDialogRef<RenameFileDialogComponent> = _self.dialog.open(RenameFileDialogComponent, { width: "600px", data: data, disableClose: true, panelClass: "no-padding-dialog-container", autoFocus: false });
    dialogRef.afterClosed().subscribe((renamedFile: FileNode) => {
      if (renamedFile) {
        _self.files.splice(_self.files.indexOf(file), 1, renamedFile);
        _self.listDataSource = new MatTableDataSource<FileNode>(_self.files);
      }
    });
  }

  public moveFile(file: FileNode): void {
    let _self = this;
    let data: FileDialogData = { files: [file], node: _self.mediaFolder, mediaTree: _self.mediaTree };
    let dialogRef: MatDialogRef<MoveFilesDialogComponent> = _self.dialog.open(MoveFilesDialogComponent, { width: "50%", data: data, minWidth: "500px", height: "600px", disableClose: true });
    dialogRef.afterClosed().subscribe((movedFiles: Array<MediaFile>) => {
      if (movedFiles && movedFiles.length > 0) {
        _self.removeFilesFromList(movedFiles);
      }
    });
  }

  public editPreview(fileNode: FileNode) {
    let _self = this;
    let previewPicker: HTMLInputElement = document.createElement('input');
    previewPicker.type = "file";
    previewPicker.accept = "image/*";
    previewPicker.onchange = (event: any) => {
      _self.utils.showShortLoader();
      let mediaFile: MediaFile = new MediaFile();
      mediaFile.mediaFileId = fileNode.mediaFileId;
      new Promise<string>((resolve, reject) => {
        let selectedFiles = event.target.files;
        if (selectedFiles && selectedFiles.length == 1) {
          const file = selectedFiles.item(0);
          var reader = new FileReader();
          var img = new Image();
          img.setAttribute("crossorigin", "anonymous");
          img.addEventListener('error', function (e) {
            console.error(e);
            reject(new Error(ErrorCodes.LOAD_PREVIEW_ERROR));
          });
          img.onload = function () {
            let canvas = document.createElement("canvas");
            canvas.height = img.height;
            canvas.width = img.width;
            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width, img.height,
              0, 0, canvas.width, canvas.height);
            let base64: string = canvas.toDataURL();
            resolve(base64);
          }

          reader.readAsDataURL(file);
          reader.onerror = function (e) {
            console.error(e);
            reject(new Error(ErrorCodes.LOAD_PREVIEW_ERROR));
          }
          reader.onload = function (data: any) {
            img.src = data.target.result;
          };
        } else {
          reject(new Error(ErrorCodes.FILE_NOT_FOUND));
        }
      }).then((base64) => {
        return _self.uploadService.uploadBase64(base64, 'tmp/preview/media-preview/', null, null)
      }).then((result: string) => {
        mediaFile.previewUrl = result;
        return _self.fileService.editPreview(mediaFile);
      }).then((data: MediaFile) => {
        fileNode.previewUrl = data.previewUrl;
      }).catch((err) => {
        _self.utils.getErrorShowToast(err);
      }).finally(() => {
        _self.utils.hideShortLoader();
      });
    };
    previewPicker.click();
  }

  public async deleteFile(file: FileNode) {
    let _self = this;
    let title: string = await _self.utils.translateKey("dialog.confirm.title.delete-file");
    let message: string = await _self.utils.translateKeyWithData("dialog.confirm.message.delete-file", { filename: file.getName(_self.utils.getLanguage()) });
    let data: ConfirmDialogData = { title: title, message: message };
    let dialogRef: MatDialogRef<ConfirmDialogComponent> = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
    dialogRef.afterClosed().subscribe((del: boolean) => {
      if (del) {
        let mediaFile: MediaFile = new MediaFile();
        mediaFile.mediaFileId = file.mediaFileId;
        _self.fileService.deleteFile(mediaFile).then(() => {
          _self.removeFilesFromList([mediaFile]);
        }).catch((err) => {
          return _self.utils.getErrorShowToast(err);
        }).finally(() => {
          _self.utils.hideShortLoader();
        });
      }
    });
  }

  ngOnInit() {
    let _self = this;
    _self.fileMenuTriggerSubscription = _self.fileMenuTrigger.onMenuClose.subscribe(() => {
      _self.selectedFile = null;
    });

    _self.selectionChangeSubscription = _self.selection.changed.subscribe((data: SelectionChange<FileNode>) => {
      if (data.added.length > 0) {
        data.added.forEach((file) => {
          file.checked = true;
        });
      }
      if (data.removed.length > 0) {
        data.removed.forEach((file) => {
          file.checked = false;
        });
      }

      _self.checkFileSelection();
    });
  }

  ngOnDestroy() {
    let _self = this;
    if (_self.fileMenuTriggerSubscription) {
      _self.fileMenuTriggerSubscription.unsubscribe();
    }

    if (_self.selectionChangeSubscription) {
      _self.selectionChangeSubscription.unsubscribe();
    }
  }

  public uploadFiles(): void {
    let _self = this;
    let data: UploadFileDialogData = { folder: _self.mediaFolder };
    let dialogRef: MatDialogRef<UploadFileDialogComponent> = _self.dialog.open(UploadFileDialogComponent, { width: "500px", data: data, height: "400px", disableClose: true });
    dialogRef.afterClosed().subscribe((uploadedFiles: Array<MediaFile>) => {
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((uploadedFile: MediaFile) => {
          _self.files.push(FileNode.fromMediaFile(uploadedFile));
          _self.listDataSource = new MatTableDataSource<FileNode>(_self.files);
        });
      }
    });
  }

  //deseleziono eventuali file selezionati
  public toggleView(): void {
    let _self = this;
    _self.gridView = !_self.gridView;
    _self.selection.clear();
  }

  public reloadFolder(): void {
    let _self = this;
    _self.loadFolder(_self.mediaFolder, _self.mediaTree);
  }

  public checkFileSelection(): void {
    let _self = this;
    _self.fileSelection = false;
    _self.files.forEach((file: FileNode) => {
      if (file.checked) {
        _self.fileSelection = true;
        return;
      }
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  public isAllSelected(): boolean {
    let _self = this;
    const numSelected = _self.selection.selected.length;
    const numRows = _self.listDataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  public masterToggle(): void {
    let _self = this;
    if (_self.isAllSelected()) {
      _self.selection.clear();
    } else {
      _self.listDataSource.data.forEach((row) => {
        _self.selection.select(row)
      });
    }
  }

  public async deleteSelected() {
    let _self = this;
    let selectedFiles: Array<FileNode> = _self.getSelectedFiles();
    if (selectedFiles && selectedFiles.length > 0) {
      let title: string = await _self.utils.translateKey("dialog.confirm.title.delete-files");
      let message: string = await _self.utils.translateKey("dialog.confirm.message.delete-files");
      let data: ConfirmDialogData = { title: title, message: message };
      let dialogRef: MatDialogRef<ConfirmDialogComponent> = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
      dialogRef.afterClosed().subscribe(async (del: boolean) => {
        if (del) {
          _self.utils.showShortLoader();
          let errors: Array<FileNode> = [];
          let deletedFiles: Array<MediaFile> = [];
          for (let i = 0; i < selectedFiles.length; i++) {
            let mediaFile: MediaFile = new MediaFile();
            mediaFile.mediaFileId = selectedFiles[i].mediaFileId;
            try {
              await _self.fileService.deleteFile(mediaFile);
              deletedFiles.push(mediaFile);
            } catch (err) {
              console.error("delete file error", selectedFiles[i]);
              errors.push(selectedFiles[i]);
            }
          }

          if (errors.length > 0) {
            let filesList: string = "";
            for (let i = 0; i < errors.length; i++) {
              filesList += errors[i].name;
              if (i + 1 != errors.length) {
                filesList += ", "
              }
            }
            let message: string = await _self.utils.translateKeyWithData("file-manager.error.delete-error", { files: filesList });
            _self.utils.showErrorToast(message);
          } else {
            let message: string = await _self.utils.translateKey("file-manager.success.delete-success");
            _self.utils.showToast(message);
          }
          _self.utils.hideShortLoader();
          _self.removeFilesFromList(deletedFiles);
        }
      });
    }
  }

  public moveSelected(): void {
    let _self = this;
    let selectedFiles: Array<FileNode> = _self.getSelectedFiles();
    if (selectedFiles && selectedFiles.length > 0) {
      let data: FileDialogData = { files: selectedFiles, node: _self.mediaFolder, mediaTree: _self.mediaTree };
      let dialogRef: MatDialogRef<MoveFilesDialogComponent> = _self.dialog.open(MoveFilesDialogComponent, { width: "50%", data: data, minWidth: "500px", height: "600px", disableClose: true });
      dialogRef.afterClosed().subscribe((movedFiles: Array<MediaFile>) => {
        if (movedFiles && movedFiles.length > 0) {
          _self.removeFilesFromList(movedFiles);
        }
      });
    }
  }

  public renameSelected(): void {
    let _self = this;
    let selectedFiles: Array<FileNode> = _self.getSelectedFiles();
    if (selectedFiles && selectedFiles.length == 1) {
      _self.renameFile(selectedFiles[0]);
    }
  }

  public getSelectedFiles(): Array<FileNode> {
    let _self = this;
    let selectedFiles: Array<FileNode> = _self.files.filter((file: FileNode) => {
      return file.checked;
    });
    return selectedFiles;
  }

  private removeFilesFromList(removedFiles: Array<MediaFile>): void {
    let _self = this;
    _self.files = _self.files.filter((file: FileNode) => {
      let found = false;
      removedFiles.forEach((movedFile: MediaFile) => {
        if (movedFile.mediaFileId == file.mediaFileId) {
          found = true;
        }
      });
      return !found;
    });
    _self.listDataSource = new MatTableDataSource<FileNode>(_self.files);
    _self.selection.clear();
  }

}
